'use client'
import styles from "@/app/styles/components/pages/cart/sender-details.module.scss";
import CartPreview from "@/app/components/pages/cart/CartPreview";
import CartProcessStep from "@/app/constants/CartProcessStep";
import {FormattedMessage} from "react-intl";
import SenderForm from "@/app/components/pages/cart/SenderForm";
import {useSelector} from "react-redux";

const SenderDetails = ({data, products, cart, changeStep, agreed, setAgreed}) => {

    const cartData = useSelector((state) => state.cart?.data);

    const handleBack = () => {
        changeStep(CartProcessStep.DELIVERY)
    }

    const handleContinue = () => {
        changeStep(CartProcessStep.PAYMENT)
    }

    const canContinue = () => {

        return cartData && cartData.senderData && cartData.senderData.first_name &&
            cartData.senderData.last_name && cartData.senderData.email && cartData.senderData.phone &&
            cartData.senderData.address_1 && cartData.senderData.city && cartData.senderData.postcode
    }

    return <div className={styles.wrapper}>
        <div className={styles.item}>
            <SenderForm/>
        </div>
        <div className={styles.item}>
            <CartPreview data={data}
                         products={products}
                         cart={cart}
                         canContinue={canContinue()}
                         backText={<FormattedMessage id={'components.pages.cart.senderDetails.back'}/>}
                         handleBack={handleBack}
                         handleContinue={handleContinue}
                         continueTitle={<FormattedMessage
                             id={'components.pages.cart.senderDetails.continueToPayment'}/>}
                        agreed={agreed}
                        setAgreed={setAgreed}
            />
        </div>
    </div>
}

export default SenderDetails